import { Box, CardMedia, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useQuery } from '@apollo/client';
import { GET_CONTENT_PAGE } from "../../apollo/getContentPage"
import { AOS_INTRO_BLOCK, AOS_INTRO_IMAGE } from "../../dataset/Animations";
import img1 from "../../images/1.png";
import img2 from "../../images/2.png";
import img3 from "../../images/3.png";
import img4 from "../../images/4.png";
import img5 from "../../images/5.png";
import RawHTML from "../SimpleResultBlock/RawHTML";

export function CustomImageBlock1() {
  return <Grid
    item
    xs={12}
    sm={12}
    md={5}
    sx={{
      display: { xs: "flex" },
      justifyContent: {xs: "center"},
      position: {
        xs: "relative",
        sm: "relative",
        md: "relative",
      },
      right: 0,
      top: {
        xs: "100px",
      },
    }}
  >
    <Box
       {...AOS_INTRO_IMAGE(1)}
      sx={{
        width: {
          xs: "100px",
          sm: "150px",
          md: "200px",
          lg: "300px",
        },
      }}
    >
      <CardMedia
        component="img"
        bgcolor={'red'}
        sx={{
          // width: "300px",
          position: "relative",
          bottom: {
            xs: "60px",
            sm: "60px",
            md: "-60px",
            lg: "-60px",
            xl: "-60px",
          },
          // left: {
          //   xs: "40px",
          //   sm: "40px",
          //   md: "60px",
          //   lg: "60px",
          //   xl: "120px",
          // },
        }}
        src={img2}
        id="img2"
        alt="bg-image"
      />
    </Box>
    <Box
       {...AOS_INTRO_IMAGE(2,true)}
      sx={{
        width: {
          xs: "100px",
          sm: "150px",
          md: "200px",
          lg: "300px",
        },
      }}
    >
      <CardMedia
        component="img"
        sx={{
          // width: "250px",
          position: "relative",
          bottom: {
            xs: "60px",
            sm: "60px",
            md: "80px",
            lg: "100px",
            xl: "100px",
          },
        }}
        src={img1}
        id="img1"
        alt="bg-image"
      />
    </Box>
  </Grid>
}

export function CustomImageBlock2() {
  return <Grid item xs={12} sm={12} md={5} sx={{ display: { xs: "flex" }, justifyContent: {xs: "center"}}}>
    <Box
       {...AOS_INTRO_IMAGE(1,true)}
      sx={{
        width: {
          xs: "100px",
          sm: "150px",
          md: "200px",
          lg: "300px",
        },
        // bgcolor: {
        //   xs: "red",
        //   sm: "green",
        //   md: "yellow",
        //   lg: "blue",
        // },
      }}
    >
      <CardMedia
        component="img"
        sx={{
          // width: "300px",
          position: "relative",
          bottom: {
            xs: "20px",
            sm: "20px",
            md: "0px",
            lg: "0px",
            xl: "0px",
          },
          left: {
            xs: "0px",
            sm: "0px",
            md: "0px",
            lg: "0px",
            xl: "0px",
          },
        }}
        src={img3}
        id="img3"
        alt="bg-image"
      />
    </Box>
    <Box
       {...AOS_INTRO_IMAGE(2)}
      sx={{
        width: {
          xs: "100px",
          sm: "150px",
          md: "200px",
          lg: "300px",
        },
      }}
    >
      <CardMedia
        component="img"
        sx={{
          width: {md: "200px", lg: "300px"},
          position: "relative",
          bottom: {
            xs: "0px",
            sm: "0px",
            md: "-240px",
            lg: "-240px",
            xl: "-240px",
          },
          left: {
            xs: "20px",
            sm: "0px",
            md: "0px",
            lg: "0px",
            xl: "0px",
          },
        }}
        src={img4}
        id="img4"
        alt="bg-image"
      />
    </Box>
  </Grid>
}

export function CustomImageBlock3() {
  return <Grid item xs={12} sm={12} md={5} sx={{}}>
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
       {...AOS_INTRO_IMAGE(3)}
        sx={{
          width: {
            xs: "200px",
            sm: "250px",
            md: "300px",
            lg: "350px",
          },
        }}
      >
        <CardMedia
          component="img"
          sx={{
            width: {lg: "400px"},
            position: "relative",
            bottom: {
              xs: "0px",
              sm: "0px",
              md: "0px",
              lg: "0px",
              xl: "0px",
            },
          }}
          src={img5}
          id="img5"
          alt="bg-image"
        />
      </Box>
    </Box>
  </Grid>
}

function AboutPageContent() {
  const [content, setContent] = useState([]);
  const [title, setTitle] = useState(["", ""]);
  const { loading, error, data } = useQuery(
    GET_CONTENT_PAGE({ page: "about", language: "ru" })
  );

  useEffect(() => {
    const contentOrder = {
      "text_first_herbariums": 0,
      "text_between_1_2_herbariums": 1,
      "text_second_herbariums": 2,
      "text_between_2_3_herbariums": 3,
      "text_third_herbariums": 4,
      "text_after_all_herbariums": 5,
    }

    if (data) {
      setContent(
        data.contentmainpage
            .filter((e) => (Object.keys(contentOrder).includes(e.contentSection)))
            .sort((a, b) => (contentOrder[a.contentSection] - contentOrder[b.contentSection]))
      );

      const titleData = data.contentmainpage.filter((e) => (e.contentSection == "title"));
      if (titleData.length > 0) {
        const titleTexts = titleData[0].text.replace(/<br\/?>/, "\n").replace(/\r+/, "\n").replace(/\n+/, "\n").split("\n");
        const titles = Array.from({ length: 2 }, (v, i) => titleTexts[i] ?? "");
        setTitle(titles);
      }
  }
  }, [data]);

  return (
    <Box id="about-project-content" className="aboutBlock" mt={10} mb={10}>
      <Grid container rowSpacing={6} columnSpacing={0} sx={{ position: 'relative' }}>
        <Grid item xs={12} sm={12} sx={{}}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Typography variant="about_title" paragraph>
              {title && title[0]}
            </Typography>
            <Typography
              variant="about_subtitle"
              paragraph
              sx={{
                fontSize: {
                  xs: "16px",
                  sm: "20px",
                  md: "36px",
                },
              }}
            >
              {title && title[1]}
            </Typography>
          </Box>
        </Grid>
        {
          content.map((paragraph, index, array) => {
            return (
              <Grid container xs={12} overflow={"hidden"}
              id={paragraph.contentSection=="text_between_1_2_herbariums"?"about-project-all-sources-block":""}
              className={paragraph.contentSection=="text_between_1_2_herbariums"?"aboutBlock":""}

              item key={new Date().toDateString()+ index+paragraph.text.slice(0,10)}>
                {
                  paragraph.contentSection == "text_second_herbariums" && <CustomImageBlock2/>
                }
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={paragraph.contentSection != "text_first_herbariums" ? paragraph.contentSection != "text_second_herbariums" ? paragraph.contentSection != "text_third_herbariums" ? 12 : 7 : 7 : 7}
                  sx={{
                    "& :first-of-type": {
                      mb: { xs: '1rem' },
                    },
                    "& >* > ol": {
                      listStyleType: 'none', /* Убираем исходные маркеры */
                      counterReset:  'item', /* Обнуляем счетчик списка */
                      "& > li:before": {
                        content: "counter(item) ') '", /* Добавляем к числам скобку */
                        counterIncrement: 'item', /* Задаём имя счетчика */
                      }
                    }
                  }}
                >
                  <Typography
                    {...AOS_INTRO_BLOCK}
                    component={"div"}
                    variant="about_text"
                    textAlign={"left"}
                    sx={{
                      fontSize: { xs: '14px', sm: '20px', md: '24px' },
                    }}>
                    <RawHTML
                      dirtyHTML={paragraph.text}
                    />
                  </Typography>
                </Grid>
                {
                  paragraph.contentSection == "text_first_herbariums" && <CustomImageBlock1 />
                }
                {
                  paragraph.contentSection == "text_third_herbariums" && <CustomImageBlock3 />
                }
              </Grid>
            )
          })
        }
      </Grid>
    </Box>
  );
}

export default AboutPageContent;
